import React, {useEffect, useState} from 'react';
import style from './table.module.css'
import {ReturnTextAndImg} from "../CheckImg";
const TableAnswers = ({ data = [], changeHandler, isPassed }) => {
    const rows = data.length || 2;
    const columns = data[0]?.length || 2;
    const [answers, setAnswers] = useState([]);
    const [isValid,setIsValid] =useState([])
    const styles = {
        right: {
            background: 'rgba(128, 253, 195, 0.76)',

        },
        wrongUser: {
            background: 'rgba(253, 128, 128, 0.76)',
        },
    }

    useEffect(() => {
        setAnswers(prevAnswers => {
            const updatedAnswers = [...prevAnswers];

            // Добавление новых строк, если необходимо
            while (updatedAnswers.length < rows) {
                updatedAnswers.push(Array(columns).fill(""));
            }

            // Добавление новых столбцов, если необходимо
            updatedAnswers.forEach(row => {
                while (row.length < columns) {
                    row.push("");
                }
            });

            return updatedAnswers;
        });
    }, [rows, columns]);
    const handlerRadioButton=(e,row,column)=> {
        const updatedAnswers = [...answers];

        if (updatedAnswers[row].includes(true)) {
            updatedAnswers[row] = updatedAnswers[row].map(item => (typeof item === "boolean" ? "" : item));
        }
        updatedAnswers[row][column] = !updatedAnswers[row][column];
        setAnswers(updatedAnswers);
        changeHandler(updatedAnswers)
    }
    const renderTable = () => {
        const table = [];

        for (let i = 0; i < rows; i++) {
            const row = [];

            for (let j = 0; j < columns; j++) {
                if (i === 0 && j === 0) {
                    row.push(
                        <td key={j}>
                            Утверждение/Высказывание
                        </td>
                    );
                } else if (i === 0 || j === 0) {
                    row.push(
                        <td key={j}>
                            {ReturnTextAndImg(data[i]?.[j]?.text || "")}
                        </td>
                    );
                } else {
                    row.push(
                        <td key={j} style={isPassed && !isValid[i-1] && data[i][j]===true ? {border:'2px solid rgba(128, 253, 195, 0.76)'}:{}}>
                            <input type="radio" onChange={e=>handlerRadioButton(e,i,j)}  checked={answers?.[i]?.[j] === true}
                                   disabled={isPassed}/>
                        </td>
                    );
                }
            }

            table.push(<tr key={i} style={isPassed && i!==0? isValid[i-1]===true ? styles.right: styles.wrongUser:{}}>{row}</tr>);
        }

        return table;
    };
    // useEffect(()=>{
    //     changeHandler(answers)
    //     },[answers])
   useEffect(()=>{
       if(isPassed){
           const arrValid=[]
           data.forEach((row,rowCount)=>{
               row.forEach((cell,cellCount)=>{
                    if(typeof cell==='boolean' && cell===true){
                        arrValid.push(!!answers[rowCount][cellCount])
                    }
               })
           })
           setIsValid(arrValid)
       }
   },[isPassed])
    return (
        <div>
            <table className={style.tableContainer}>
                <tbody>{renderTable()}</tbody>
            </table>
        </div>
    );
};

export default TableAnswers;
